module.exports = __webpack_public_path__ + "images/icon-events-notfound-c2c137076c7801b5235b0ac24fc3f1c1.png";